import {Stack} from '@mui/material';
import SecondaryButton from '../../../common/StyledComponents/SecondaryButton';
import PrimaryButton from '../../../common/StyledComponents/PrimaryButton';
import {useEffect, useState} from 'react';
import {signUpDialogOpenState} from '../../../recoil/dialogs/DialogsRecoil';
import {useRecoilState, useSetRecoilState} from 'recoil';
import {loadingState} from '../../../recoil/bidmiiCustomLoader/bidmiiCustomLoaderAtom';
import {useHistory} from 'react-router-dom';
import LoginDialog from './LoginDialog';

export default function LoginNav(props: $TSFixMe) {
  const history = useHistory();
  const setLoading = useSetRecoilState(loadingState);
  const [signUpDialogOpen, setSignUpDialogOpen] = useRecoilState(
    signUpDialogOpenState,
  );
  const [open, setOpen] = useState(signUpDialogOpen ? true : false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSignUpDialogOpen(false);
  };

  useEffect(() => {
    if (signUpDialogOpen) {
      process.env.NODE_ENV === 'development' &&
        console.log('OPENING SIGN UP DIALOG');
      setOpen(true);
      setLoading(false);
    } else {
      process.env.NODE_ENV === 'development' &&
        console.log('not opening sign up dialog');
    }
  }, [setLoading, signUpDialogOpen]);

  return (
    <>
      <Stack
        gap={2}
        p={props.isMobile ? 2 : 0}
        direction={props.isMobile ? 'column' : 'row'}>
        <SecondaryButton onClick={() => history.push('/m/contractors')}>
          I'M A CONTRACTOR
        </SecondaryButton>
        <PrimaryButton id={'sign-up-button'} onClick={handleClickOpen}>
          SIGN UP
        </PrimaryButton>
      </Stack>

      <LoginDialog open={open} onClose={handleClose} />
    </>
  );
}
